/**
 * Home Page - Landing Page
 */

import { Logo } from '@/components/Logo';
import { Link } from 'wouter-preact';

export function HomePage() {

  return (
    <div class="min-h-full flex flex-col items-center overflow-hidden">
      <header class="absolute w-80 z-10 flex items-center justify-between h-14 rounded-full bg-neutral-900 shadow-lg backdrop-blur-sm pl-4 pr-6 mt-8 border-neutral-800">
        <div class="w-full flex items-center gap-2.5 font-semibold text-base min-w-0">
          <Link href="/">
            <Logo size={8} />
          </Link>
          <Link href="/" class="text-base font-black italic -ml-0.5 z-10">Nitros</Link>
          <div class="flex items-center gap-4 ml-auto">
            <Link href="/build" class="text-base font-medium text-neutral-600 hover:text-neutral-400">Create</Link>
            <Link href="/store" class="text-base font-medium text-neutral-600 hover:text-neutral-400">Explore</Link>
          </div>
        </div>
      </header>
      {/* Hero Section */}
      <section class="flex-1 col aic jcc px-6 py-12 sm:py-16">
        <div class="w-full h-full flex-1 relative mb-8">
          <div class="absolute bottom-0 left-1/2 -translate-x-1/2 -translate-y-[12%]">
            <Logo size={300} />
          </div>
        </div>
        {/* <h1 class="absolute top-32 left-1/2 -translate-x-1/2 -translate-y-1/2 text-9xl font-black tracking-tight text-center text-white/20 mix-blend-soft-light">N2O</h1> */}
        <div class="col gap-7">
          <div class="col gap-4">
            <h2 class="text-(neutral-300 center xl sm:2xl md:3xl lg:4xl) max-w-[30ch] mx-auto tracking-tight">
              Clickable full-stack apps built first and foremost to run on localhost
            </h2>
            <p class="text-(neutral-600 center base sm:lg md:xl lg:2xl) mx-auto tracking-tight">
              {/* Sandboxed – No Infrastructure – Distributed */}
              Distributed and served without infrastructure
              {/* Built on Vite, Nitro, Deno and Electron */}
              {/* The headless UI for distributed server code */}
            </p>
          </div>
          <div class="row gap-6 justify-center items-center py-1 pl-6 pr-1.5 bg-neutral-800 rounded-full self-center">
            <code class="text-neutral-500 text-xl row gap-2 aic">
              <svg viewBox="0 0 12.32 9.33" aria-hidden="true" class="w-5 h-5 text-neutral-200 fill-current"><g><line class="st1" x1="7.6" y1="8.9" x2="7.6" y2="6.9"></line><rect width="1.9" height="1.9"></rect><rect x="1.9" y="1.9" width="1.9" height="1.9"></rect><rect x="3.7" y="3.7" width="1.9" height="1.9"></rect><rect x="1.9" y="5.6" width="1.9" height="1.9"></rect><rect y="7.5" width="1.9" height="1.9"></rect></g></svg>
              <span class="text-neutral-400 text-[0.8em] mr-20">
                npx nitros
              </span>
              <button onClick={() => navigator.clipboard.writeText('npx nitros')} class="hover:text-neutral-200 transition-all duration-200 bg-neutral-900/50 hover:bg-neutral-700 rounded-full p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy-icon lucide-copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2" /><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" /></svg>
              </button>
            </code>
          </div>
        </div>
      </section >
    </div >
  );
}
